import {getCookie, setCookie} from '../helpers';

const DisclaimerComponent = () => {
  const disclaimer = 'disclaimer';
  const actionClass = 'disclaimer__action';
  const visibleClass = 'disclaimer--visible';
  const acceptedValue = 'true';

  let accepted = getCookie(disclaimer);

  if (accepted !== acceptedValue) {
    let disclaimerElement = document.getElementById(disclaimer);
    let disclaimerAction = document.getElementById(actionClass);

    disclaimerElement.classList.add(visibleClass);

    disclaimerAction.addEventListener('click', () => {
      disclaimerElement.classList.remove(visibleClass);

      setCookie(disclaimer, acceptedValue, {
        expires: new Date().getTime() + 1000 * 60 * 60 * 24 * 365
      });
    });
  }
};

export const Disclaimer = () => {
  $(document).ready(() => DisclaimerComponent());
};
